import { Component, inject, OnInit } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { TableLazyLoadEvent, TableModule } from 'primeng/table'
import { TabViewModule } from 'primeng/tabview'
import { TagModule } from 'primeng/tag'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { JobService } from '../../services/job.service'
import { JobModel, FailedJobModel } from '../../../../core/models/job.model'

@Component({
  selector: 'app-jobs',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    TabViewModule,
    TagModule,
    CardModule,
    ButtonModule,
    TooltipModule,
    DatePipe,
  ],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.scss',
})
export class JobsComponent implements OnInit {
  private jobService = inject(JobService)

  public pendingJobs$ = this.jobService.pendingJobs$
  public failedJobs$ = this.jobService.failedJobs$
  public pendingTotal$ = this.jobService.pendingTotal$
  public failedTotal$ = this.jobService.failedTotal$
  public pendingLoading$ = this.jobService.pendingLoading$
  public failedLoading$ = this.jobService.failedLoading$

  ngOnInit() {
    this.jobService.getPendingJobs().subscribe()
    this.jobService.getFailedJobs().subscribe()
  }

  onPendingLazyLoad(event: TableLazyLoadEvent) {
    const page =
      event.first !== undefined && event.rows
        ? Math.floor(event.first / event.rows) + 1
        : 1
    const perPage = event.rows ?? 15
    this.jobService.getPendingJobs(page, perPage).subscribe()
  }

  onFailedLazyLoad(event: TableLazyLoadEvent) {
    const page =
      event.first !== undefined && event.rows
        ? Math.floor(event.first / event.rows) + 1
        : 1
    const perPage = event.rows ?? 15
    this.jobService.getFailedJobs(page, perPage).subscribe()
  }

  getStatusSeverity(
    status: JobModel['status']
  ): 'success' | 'warn' | 'danger' | 'info' {
    return status === 'reserved' ? 'warn' : 'info'
  }

  shortJobName(name: string): string {
    const parts = name.split('\\')
    return parts[parts.length - 1]
  }
}
